import Tabs from '@cloudscape-design/components/tabs';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import OrderDetailProvider from '../../components/Orders/orderDetailProvider';
import OrderListPage from './list';

export default function OrdersPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabId, setActiveTabId] = useState(searchParams.get('type') || OrderTypes.CUSTOMER);

  return (
    <OrderDetailProvider>
      <Tabs
        activeTabId={activeTabId}
        onChange={({ detail }) => {
          setActiveTabId(detail.activeTabId);
          setSearchParams({ type: detail.activeTabId });
        }}
        tabs={[
          {
            label: 'Customer Orders',
            id: OrderTypes.CUSTOMER,
            content: <OrderListPage />,
          },
          {
            label: 'Internal Orders',
            id: OrderTypes.INTERNAL,
            content: <OrderListPage isInternal />,
          },
        ]}
      />
    </OrderDetailProvider>
  );
}
